var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.064 2.18l3.698 4.434a.317.317 0 00.476 0l3.698-4.435a.27.27 0 00-.052-.397.31.31 0 00-.186-.06H.302c-.167 0-.302.127-.302.283 0 .063.023.125.064.175z",
    fill: "#61656F",
    fillRule: "nonzero"
  })));
}
export default SvgDownArrowFilled;